import { MakeupStatus } from "@/openapi/generated";
import {
  type StaffReviewConflict,
  StaffReviewConflictError,
  formatStaffReviewConflictMessage,
  parseStaffReviewConflictFromError,
  parseStaffReviewConflictFromResponse,
} from "@/lib/review-concurrency/staff-review-conflict";

export type MakeupReviewConflict = StaffReviewConflict;

export {
  parseStaffReviewConflictFromResponse as parseMakeupReviewConflictFromResponse,
  parseStaffReviewConflictFromError as parseMakeupReviewConflictFromError,
};

export class MakeupReviewConflictError extends StaffReviewConflictError {
  constructor(conflict: MakeupReviewConflict) {
    super(conflict);
    this.name = "MakeupReviewConflictError";
  }
}

export function formatMakeupReviewConflictMessage(
  conflict: MakeupReviewConflict,
  action: "approve" | "reject" | "propose" | "cancel" | "generic" = "generic",
): string {
  const who = conflict.actedByEmail;
  const at = conflict.actedAt ? ` at ${new Date(conflict.actedAt).toLocaleString()}` : "";
  const status = conflict.currentStatus;

  if (status === MakeupStatus.Approved) {
    return `${who} already approved this${at}.`;
  }
  if (status === MakeupStatus.Rejected) {
    return `${who} already declined this${at}.`;
  }
  if (status === MakeupStatus.ChangeRequested) {
    return `${who} already sent a proposal${at}.`;
  }

  return formatStaffReviewConflictMessage(
    conflict,
    action === "propose" ? "generic" : action === "cancel" ? "cancel" : action,
  );
}
